import { Component } from '@angular/core';

@Component({
  selector: 'lib-panel-layout',
  host: {
    class: 'block h-full min-h-0 w-full min-w-0 ',
  },
  template: `
    <div class="h-full min-h-0 w-full min-w-0 overflow-hidden">
      <div class="flex h-full min-h-0 w-full min-w-0 flex-col gap-2 overflow-hidden">
        <div class="flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto overscroll-contain p-2 py-2">
          <ng-content />
        </div>
        <div class="w-full shrink-0 empty:hidden px-2 pb-2">
          <ng-content select="[panelActions]" />
        </div>
      </div>
    </div>
  `,
})
export class PanelLayoutComponent {}
